import { mapperEventAgendaSectionItem } from '../event-agenda-section-item/mapper-event-agenda-section-item'

/**
 * BlockEventAgendaSectionItem
 * @param {Object} data, content data
 * @return {Object} normalized data
 */

export const mapperEventAgendaSection = (data: any) => {
  if (!data) {
    return null
  }
  return {
    id: data.sys?.id || '',
    contentType: data.contentType,
    title: data.title || '',
    items: data.agendaSectionItemsCollection?.items?.map(mapperEventAgendaSectionItem) || []
  }
}
